(() => {
  const CONTEXT_ORDER = {
    cameras: ['category', 'condition', 'price', 'weight', 'megapixels', 'fps', 'sensor', 'iso', 'memory', 'mount', 'brand', 'type'],
    lenses: ['category', 'brand', 'type', 'mount', 'aperture_wide', 'aperture_tele', 'filter_thread', 'min_focus', 'condition', 'price'],
    video: ['category', 'condition', 'price', 'weight', 'video', 'memory', 'mount', 'brand', 'type'],
    accessories: ['category', 'type', 'condition', 'price', 'brand', 'accessories_included', 'camera_support'],
    brand: ['category', 'condition', 'price', 'weight', 'megapixels', 'sensor', 'mount', 'memory', 'type'],
    default: ['category', 'condition', 'price', 'brand', 'type', 'weight', 'megapixels', 'fps', 'sensor', 'iso', 'memory', 'mount', 'aperture_wide', 'aperture_tele', 'filter_thread', 'min_focus']
  };

  const DISPLAY = {
    type: 'Tipo di prodotto',
    brand: 'Marchio',
    category: 'Categoria',
    condition: 'Condizione estetica',
    price: 'Prezzo',
    weight: 'Peso',
    megapixels: 'Megapixel',
    fps: 'Fotogrammi al secondo massimi',
    sensor: 'Formato Sensore',
    iso: 'Massimo ISO',
    memory: 'Tipo di supporto di memorizzazione',
    mount: "Attacco dell'obiettivo",
    viewfinder: 'Mirino',
    usb: 'Tipo di porta USB',
    video: 'Risoluzione video massima',
    aperture_wide: 'Apertura massima ampia F',
    aperture_tele: 'Teleobiettivo con apertura massima F',
    filter_thread: 'Filettatura filtro (mm)',
    min_focus: 'Distanza minima di messa a fuoco',
    release_year: 'Anno di uscita',
    shutter: 'Numero scatti',
    accessories_included: 'Accessori inclusi',
    accessories_extra: 'Accessori extra',
    camera_support: 'Supporto fotocamera'
  };

  // I matcher piu specifici devono precedere quelli generici.
  const MATCHERS = {
    memory: ['tipo di supporto di memorizzazione', 'supporto di memorizzazione', 'supporto memoria', 'schede di memoria compatibili', 'tipo di storage della memoria', 'storage media type', 'memory card type', 'memory cards', 'storage', 'memoria', 'memory_type', 'memory combo', 'memory_combo'],
    mount: ["attacco dell'obiettivo", 'attacco obiettivo', 'tipo di montaggio della fotocamera', 'lens mount', 'lens_mount', 'mount'],
    sensor: ['dimensioni del sensore di immagine', 'formato del sensore', 'formato sensore', 'tipo di sensore della fotocamera', 'sensor format', 'sensor_format', 'sensor'],
    condition: ['condizione estetica', 'condition_grade', 'cosmetic condition', 'condizione', 'condition'],
    megapixels: ['megapixels', 'megapixel'],
    fps: ['fotogrammi al secondo massimi', 'fotogrammi al secondo max', 'maximum frames per second', 'maximum fps', 'max fps', 'max_fps', 'fps'],
    iso: ['massimo iso', 'maximum iso', 'max iso', 'max_iso', 'iso'],
    weight: ['peso (g)', 'peso (grammi)', 'weight_g', 'weight (grams)', 'weight', 'peso'],
    price: ['prezzo', 'price'],
    aperture_wide: ['aperture_max_wide', 'apertura massima ampia f', 'apertura massima ampia', 'wide max aperture', 'max aperture wide', 'max aperture (wide)', 'apertura massima wide'],
    aperture_tele: ['aperture_max_tele', 'teleobiettivo con apertura massima f', 'teleobiettivo con apertura massima', 'tele max aperture', 'max aperture telephoto', 'max aperture (telephoto)', 'max aperture (tele)', 'apertura massima tele'],
    filter_thread: ['filter_thread_mm', 'filettatura filtro', 'filettatura filtro mm', 'filter thread', 'filter thread mm'],
    min_focus: ['min_focus_distance', 'distanza minima di messa a fuoco', 'minimum focus distance', 'min focus distance'],
    video: ['video_resolution_max', 'risoluzione video massima', 'massima risoluzione video', 'maximum video resolution', 'video resolution'],
    viewfinder: ['mirino', 'viewfinder'],
    usb: ['tipo di porta usb', 'porta usb', 'usb port type', 'usb'],
    shutter: ['shutter_count', 'numero scatti', 'shutter count', 'scatti'],
    release_year: ['anno di uscita', 'release year', 'year'],
    accessories_included: ['accessori inclusi', 'accessories included'],
    accessories_extra: ['accessori extra', 'extra accessories'],
    camera_support: ['supporto per fotocamera', 'supporto fotocamera', 'camera support'],
    brand: ['marchio', 'brand', 'vendor', 'venditore', 'produttore'],
    category: ['macro_category', 'macro categoria', 'categoria', 'category'],
    type: ['tipo di prodotto', 'tipo prodotto', 'product type', 'product category', 'tipo di obiettivi', 'tipo obiettivo', 'lens type', 'type']
  };

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9_]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function canonicalKey(label) {
    const norm = normalize(label);
    if (!norm) return null;
    const matches = [];

    Object.entries(MATCHERS).forEach(([key, phrases]) => {
      phrases.forEach((phrase) => {
        const normalizedPhrase = normalize(phrase);
        if (!normalizedPhrase) return;
        if (norm === normalizedPhrase) {
          matches.push({ key, score: 10000 + normalizedPhrase.length });
        } else if (norm.includes(normalizedPhrase)) {
          matches.push({ key, score: 5000 + normalizedPhrase.length });
        }
      });
    });

    if (!matches.length) return null;
    matches.sort((a, b) => b.score - a.score);
    return matches[0].key;
  }

  function inferContextFromUrl() {
    const path = normalize(window.location.pathname);
    if (path.includes('obiettivi') || path.includes('lenti') || path.includes('lens') || path.includes('lenses')) return 'lenses';
    if (path.includes('fotocamere') || path.includes('macchine fotografiche') || path.includes('camera') || path.includes('cameras') || path.includes('reflex') || path.includes('mirrorless') || path.includes('compatt')) return 'cameras';
    if (path.includes('videocamere') || path.includes('video')) return 'video';
    if (path.includes('accessori') || path.includes('accessories')) return 'accessories';
    return 'default';
  }

  function contextualKey(key) {
    // Il cliente vuole Categoria visibile, quindi non la convertiamo in Tipo prodotto.
    return key || null;
  }

  function contextOrder(context) {
    return CONTEXT_ORDER[context] || CONTEXT_ORDER.default;
  }

  function contextOrderMap(context) {
    return contextOrder(context).reduce((acc, key, index) => {
      acc[key] = index;
      return acc;
    }, {});
  }

  function labelTarget(detail) {
    return detail.querySelector('.facets__summary-label') || detail.querySelector('.mobile-facets__summary span') || detail.querySelector('summary span') || detail.querySelector('summary');
  }

  function getRawLabel(detail) {
    return String(detail.dataset.filterLabel || labelTarget(detail)?.textContent || '').trim();
  }

  function relabelDetail(detail, context) {
    const raw = getRawLabel(detail);
    const key = contextualKey(canonicalKey(raw), context);

    if (!key) {
      detail.dataset.scattaUnknown = 'true';
      detail.dataset.scattaKey = '';
      return null;
    }

    detail.dataset.scattaUnknown = 'false';
    detail.dataset.scattaKey = key;
    const target = labelTarget(detail);
    if (target && DISPLAY[key]) target.textContent = DISPLAY[key];
    return key;
  }

  function getFilterDetails(container) {
    if (!container) return [];
    const directDetails = Array.from(container.children).filter((child) => child.classList?.contains('js-filter'));
    if (directDetails.length) return directDetails;
    return Array.from(container.querySelectorAll('.js-filter'));
  }

  function reorderChildrenIfNeeded(container, orderedDetails) {
    if (!container || !orderedDetails.length) return;
    const directDetails = Array.from(container.children).filter((child) => child.classList?.contains('js-filter'));
    if (!directDetails.length) return;
    const orderedDirectDetails = orderedDetails.filter((detail) => directDetails.includes(detail));
    const alreadyInOrder = directDetails.length === orderedDirectDetails.length && directDetails.every((el, index) => el === orderedDirectDetails[index]);
    if (alreadyInOrder) return;
    const fragment = document.createDocumentFragment();
    orderedDirectDetails.forEach((detail) => fragment.appendChild(detail));
    container.appendChild(fragment);
  }

  function sortAndFilterDetails(container, context) {
    if (!container) return;
    const details = getFilterDetails(container);
    const orderMap = contextOrderMap(context);
    const seenKeys = new Set();

    details.forEach((detail) => {
      const key = relabelDetail(detail, context);
      detail.classList.remove('scatta-filter-hidden');
      // Nasconde solo duplicati dello stesso filtro. I filtri nuovi/non riconosciuti restano visibili.
      if (key && seenKeys.has(key)) {
        detail.classList.add('scatta-filter-hidden');
        return;
      }
      if (key) seenKeys.add(key);
    });

    const ordered = details.slice().sort((a, b) => {
      const aKey = a.dataset.scattaKey || '';
      const bKey = b.dataset.scattaKey || '';
      const aOrder = Object.prototype.hasOwnProperty.call(orderMap, aKey) ? orderMap[aKey] : 999;
      const bOrder = Object.prototype.hasOwnProperty.call(orderMap, bKey) ? orderMap[bKey] : 999;
      return aOrder - bOrder;
    });

    reorderChildrenIfNeeded(container, ordered);
  }

  function relabelActiveFacets(wrapper, context) {
    wrapper.querySelectorAll('.active-facets__button').forEach((button) => {
      const raw = button.dataset.filterLabel || button.getAttribute('aria-label') || button.textContent || '';
      const key = contextualKey(canonicalKey(raw), context);
      if (!key || !DISPLAY[key]) return;
      const inner = button.querySelector('.active-facets__button-inner');
      if (!inner) return;
      inner.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.includes(':')) {
          node.textContent = node.textContent.replace(/^.*?:/, `${DISPLAY[key]}:`);
        }
      });
    });
  }

  function relabelSort(wrapper) {
    wrapper.querySelectorAll('.facet-filters__label label').forEach((label) => { label.textContent = 'Ordina per'; });
    wrapper.querySelectorAll('.mobile-facets__open-label').forEach((label) => { if (label.textContent.trim()) label.textContent = 'Filtri'; });
    wrapper.querySelectorAll('.mobile-facets__heading').forEach((label) => { if (label.textContent.trim()) label.textContent = 'Filtri'; });
    wrapper.querySelectorAll('.mobile-facets__footer .button').forEach((button) => { button.textContent = 'Applica'; });
    wrapper.querySelectorAll('.mobile-facets__clear').forEach((link) => { link.textContent = 'Annulla'; });
  }

  function apply(wrapper) {
    if (!wrapper) return;
    const context = wrapper.dataset.scattaContext || wrapper.getAttribute('data-scatta-context') || inferContextFromUrl();
    sortAndFilterDetails(wrapper.querySelector('#FacetsWrapperDesktop'), context);
    sortAndFilterDetails(wrapper.querySelector('#FacetsWrapperMobile'), context);
    sortAndFilterDetails(wrapper.querySelector('.mobile-facets__main'), context);
    relabelActiveFacets(wrapper, context);
    relabelSort(wrapper);
  }

  function scheduleApply(wrapper) {
    if (!wrapper || wrapper.__scattaApplyScheduled) return;
    wrapper.__scattaApplyScheduled = true;
    requestAnimationFrame(() => {
      wrapper.__scattaApplyScheduled = false;
      const observer = wrapper.__scattaObserver;
      if (wrapper.__scattaApplying) return;
      wrapper.__scattaApplying = true;
      if (observer) observer.disconnect();
      try { apply(wrapper); }
      finally {
        if (observer) observer.observe(wrapper, { childList: true, subtree: true });
        wrapper.__scattaApplying = false;
      }
    });
  }

  function bindAutoClose(wrapper) {
    if (wrapper.dataset.scattaAutoCloseBound === 'true') return;
    wrapper.dataset.scattaAutoCloseBound = 'true';
    wrapper.addEventListener('change', (event) => {
      const details = event.target.closest('.js-filter');
      if (!details) return;
      if (!window.matchMedia('(min-width: 990px)').matches) return;
      window.setTimeout(() => details.removeAttribute('open'), 50);
    });
  }

  function watchWrapper(wrapper) {
    if (wrapper.dataset.scattaFiltersBound === 'true') return;
    wrapper.dataset.scattaFiltersBound = 'true';
    bindAutoClose(wrapper);
    const observer = new MutationObserver(() => scheduleApply(wrapper));
    wrapper.__scattaObserver = observer;
    observer.observe(wrapper, { childList: true, subtree: true });
    scheduleApply(wrapper);
  }

  function init() {
    document.querySelectorAll('.scatta-filters-v2').forEach((wrapper) => watchWrapper(wrapper));
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
})();
